import { BaseService } from '../../../../../core/services/base.service';
import { FeatureJob } from '../models/featurejobs.model';
import { Job } from '../../job/models/job.model';
import { UtilService } from '../../../../../core/services/util.service';

export class FeatureJobsService {
  static async Get(
    params?: {
      page?: number;
      size?: number;
      sort?: string;
      filter?: string;
    },
    CallbackCatch?: (error: Error) => void
  ): Promise<{ content: FeatureJob[]; totalElements: number }> {
    const query = params
      ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
      : '';

    const result = CallbackCatch
      ? await BaseService.Get(`/featured/jobs${query}`, CallbackCatch, false)
      : await BaseService.Get(`/featured/jobs${query}`);

    if (!result) {
      return { content: [], totalElements: 0 };
    }
    return {
      content: Array.isArray(result.content) ? result.content : [],
      totalElements: result.totalElements ?? 0,
    };
  }

  static async GetJob(
    id: string,
    CallbackCatch?: (error: Error) => void
  ): Promise<FeatureJob> {
    let callbackcatch = (error: Error) => {
      if (['400', '404'].includes(error.message)) {
        UtilService.Alert(
          'Important!',
          'info',
          'The job entered does not exist'
        );
      } else {
        UtilService.Alert('Important!', 'info', 'Internal Server Error');
      }
    };

    if (CallbackCatch) {
      callbackcatch = CallbackCatch;
    }

    return await BaseService.Get(`/public/jobs/${id}`, callbackcatch);
  }
  static async Add(job: Job): Promise<Job> {
    let toAdd: Partial<Job> = {
      name: job.name,
      category: job.category,
      subCategory: job.subCategory,
      description: job.description,
      location: job.location,
    };

    return await BaseService.Post('/featured/jobs', toAdd);
  }

  static async Edit(job: Job, id: string): Promise<Job> {
    let toAdd: Partial<Job> = {
      name: job.name,
      category: job.category,
      subCategory: job.subCategory,
      description: job.description,
      location: job.location,
      draft: job.draft,
      published: job.published,
    };

    return await BaseService.Patch(`/featured/jobs/${id}`, toAdd);
  }

  static async Publish(id: string): Promise<Job[]> {
    return await BaseService.Patch(`/jobs/${id}/featured/true`);
  }

  static async Delete(id: string): Promise<Job[]> {
    return await BaseService.Delete(`/jobs/${id}?hardDelete=false`);
  }

  static async Restore(id: string): Promise<void> {
    return await BaseService.Patch(`/jobs/${id}/restore`);
  }
}
